import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import AirDatepicker from "air-datepicker";
import localeEn from 'air-datepicker/locale/en';
import compile from "../utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import bdapi from "@bd-core/bd-api";
import moment from 'moment';
// import 'selectize'; <!-- PREPARE TIMEZONE OPTION -->
// import 'selectize/dist/css/selectize.default.css';
import 'moment-timezone';

export const SessionsPage = () => {
    const isSessionsPage = $("#page-sessions").length > 0;

    if (!isSessionsPage) return;

    // toggle the session for team or individual
    const currentPage = window.location.href;
    const currentPageUrl = new URL(currentPage);
    const methodOfPlaying = currentPageUrl.searchParams.get("method");
    const isTeam = methodOfPlaying === "team";

    const $sessionScreen = $(".session");
    $sessionScreen.toggleClass("is-team", isTeam)

    bdjs.hideLoading();

    // Snackbar Component
    // ------------------------------------------------------------------------
    const $snackBar = $(".snackbar");
    $snackBar.find(".snackbar__close").on("click", function (e) {
        e.preventDefault();
        $snackBar.removeClass("is-active");
    });

    const getSessions = async (date, methodOfPlaying) => {
        const [res] = await bdjs.goAsync(
            bdapi.post("public/get-sessions", {
                date: date,
                method: methodOfPlaying
            }),
        );

        const restData = res?.data || {};

        return restData;
    }

    const transformTimezone = (schedule_date, schedule_time, timezone) => {
        const localDateTime = `${schedule_date} ${schedule_time}`;
        const localFormat = "YYYY-MM-DD HH:mm";

        // Parse local time with timezone
        const localMoment = moment.tz(localDateTime, localFormat, timezone);
        const selectedTime = localMoment.format("HH:mm [UTC]Z");

        return {
            selectedTimeUTC: selectedTime
        };
    };

    const convertTimezone = (session_date, timezone) => {
        // Parse session_date and timezone
        const [dateStr, timeStr, tzStr] = session_date.split(" ");

        // Initialize date variable
        let date;

        // Special handling for CET to match PHP behavior
        if (tzStr === "CET") {
            // Create moment object and force GMT+1
            const baseDate = moment(
                `${dateStr} ${timeStr}`,
                "YYYY-MM-DD HH:mm",
            );
            date = baseDate.utcOffset(60, true); // 60 minutes = GMT+1, true keeps the offset fixed
        } else {
            // Normal timezone parsing for other timezones
            date = moment.tz(`${dateStr} ${timeStr}`, tzStr);
        }

        const parsedTz = timezone !== "null" ? timezone : "UTC";

        // Convert the timezone using moment-timezone
        if (parsedTz !== "CET") {
            date = date.tz(parsedTz);
        } else {
            // For CET output, force GMT+1 and keep it fixed
            date = date.utcOffset(60, true);
        }

        // Format the converted date with timezone offset
        const formattedDate = date.format("HH:mm [UTC]Z");

        return formattedDate;
    };

    const convertTexttoDateFormat = (inputDate) => {
        // Create a new Date object from the input string
        var dateObj = new Date(inputDate);

        // Get the year, month, and day from the date object
        var year = dateObj.getFullYear();
        var month = ('0' + (dateObj.getMonth() + 1)).slice(-2); // Adding 1 to month since it's zero-based index
        var day = ('0' + dateObj.getDate()).slice(-2);

        // Construct the new date string in the "YYYY-MM-DD" format
        var newDateString = year + '-' + month + '-' + day;

        return newDateString;
    }

    const renderTimeTable = async (date) => {
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = newDate.getMonth() + 1;
        const day = newDate.getDate();
        const dateTxt = day <= 9 ? `0${day}` : day;
        const monthTxt = month <= 9 ? `0${month}` : month;
        const theDate = `${year}-${monthTxt}-${dateTxt}`;

        const $timeCard = $(".js-time");
        const $timeTableScreen = $timeCard.parents(".js-session-timeTable");
        const currentMonth = Number(
            $timeTableScreen.attr("data-session-month"),
        );

        if (month !== currentMonth) {
            const restData = await getSessions(theDate, methodOfPlaying);
            const updatedSessions = restData?.data?.sessions;
            CONFIG.game.sessions = updatedSessions;
        }

        let sessions = CONFIG.game.sessions;
        let todaySession = sessions[theDate] || {};
        // Return early if no sessions for today
        if (Object.keys(todaySession).length === 0) {
            $(".session-card_wrapper").html("");
            $timeTableScreen.attr("data-session-date", theDate);
            $timeTableScreen.attr("data-session-month", month);
            return;
        }

        // Sort todaySession based on key (time)
        todaySession = Object.keys(todaySession)
            .sort()
            .reduce((obj, key) => {
                obj[key] = todaySession[key];
                return obj;
            }, {});

        const groupPerHour = {};
        Object.keys(todaySession).forEach((time) => {
            const timeParts = time.split(":");
            const hour = timeParts[0];
            if (!groupPerHour[hour]) {
                groupPerHour[hour] = [];
            }

            groupPerHour[hour].push({
                time: time,
                sessions: todaySession[time],
            });
        });

        const varietyPerHour = {};
        Object.keys(groupPerHour).forEach((hour) => {
            const hourSessions = groupPerHour[hour];
            // Sort each session array by session name
            hourSessions.forEach((session) => {
                session.sessions.sort((a, b) => {
                    if (!a.session_name) return -1;
                    if (!b.session_name) return 1;
                    return a.session_name.localeCompare(b.session_name);
                });
            });

            const longest = hourSessions.reduce((max, curr) => {
                return curr.sessions.length > (max.sessions?.length || 0)
                    ? curr
                    : max;
            }, {});

            const maxLength = longest.sessions?.length || 0;
            if (!varietyPerHour[hour]) {
                varietyPerHour[hour] = [];
            }

            for (let i = 0; i < maxLength; i++) {
                hourSessions.forEach((session) => {
                    if (session.sessions[i]) {
                        varietyPerHour[hour].push(session.sessions[i]);
                    }
                });
            }
        });

        const template = $("#js-session-container-template").html();
        let number = 0;
        let maxColumn = 0;

        $(".session-card_wrapper").html("");
        Object.entries(varietyPerHour)
            .sort(([a], [b]) => parseInt(a) - parseInt(b))
            .forEach(([hour, _sessions]) => {
                let sessionHtml = "";
                let additionalColumn = 0;
                _sessions.forEach((session, index) => {
                    let className = `at-${parseInt(hour)}`;
                    const suffixTime = session.session_time.split(":")[1];
                    if (suffixTime === "15") {
                        className += ` increment-${1}`;
                    } else if (suffixTime === "30") {
                        className += ` increment-${2}`;
                    } else if (suffixTime === "45") {
                        className += ` increment-${3}`;
                    } else {
                        className += ` increment-${0}`;
                    }

                    let possibleColumn = index + additionalColumn;
                    let isOverlapping = true;
                    while (isOverlapping) {
                        const $topSibling = $(
                            `.at-${parseInt(hour) - 1}.pos-${possibleColumn}`,
                        );

                        let quarterSibling = false;
                        if (suffixTime === "00") {
                            quarterSibling =
                                $topSibling.hasClass(`increment-${1}`) ||
                                $topSibling.hasClass(`increment-${2}`) ||
                                $topSibling.hasClass(`increment-${3}`);
                        } else if (suffixTime === "15") {
                            quarterSibling =
                                $topSibling.hasClass(`increment-${2}`) ||
                                $topSibling.hasClass(`increment-${3}`);
                        } else if (suffixTime === "30") {
                            quarterSibling = $topSibling.hasClass(
                                `increment-${3}`,
                            );
                        }

                        if ($topSibling.length > 0 && quarterSibling) {
                            possibleColumn += 1;
                            additionalColumn += 1;
                        } else {
                            isOverlapping = false;
                        }
                    }
                    className += ` pos-${possibleColumn}`;
                    if (possibleColumn > maxColumn) {
                        maxColumn = possibleColumn;
                    }

                    let html;

                    session = {
                        ...session,
                        className: className,
                    };

                    html = compile(template, session);
                    sessionHtml += html;
                });

                if (number === 0) {
                    $(".session-card_wrapper").html(sessionHtml);
                } else {
                    $(".session-card_wrapper").append(sessionHtml);
                }
                number++;
            });

        $(".session_timeTable-main--sessions")
            .removeClass((index, className) => {
                return (className.match(/(^|\s)type-\S+/g) || []).join(" ");
            })
            .addClass(`type-${maxColumn + 1}`);

        $timeTableScreen.attr("data-session-date", theDate);
        $timeTableScreen.attr("data-session-month", month);
    };

    const transformDates = (date) => {
        const selectedDate = new Date(date);
        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const monthsOfYear = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const dayOfWeek = daysOfWeek[selectedDate.getDay()];
        const dayOfMonth = selectedDate.getDate();
        const month = monthsOfYear[selectedDate.getMonth()];
        const year = selectedDate.getFullYear();

        const formattedDate = `${dayOfWeek}, ${dayOfMonth} ${month} ${year}`;

        return formattedDate;
    }

    const DatePicker = () => {
        let datepickerInstance;
        let dates = new Date().toLocaleDateString();
        let markedDates = CONFIG.game.sessions.available_session;

        datepickerInstance = new AirDatepicker('#datePicker', {
            inline: true,
            locale: localeEn,
            selectedDates: [new Date()],
            onSelect: function (date) {
                if (!date.formattedDate) return;
                // set onSelect date
                $(".js-close-sidebar").trigger("click");
                $(".js-currentDate")
                    .html(transformDates(date.formattedDate.toString()))
                dates = date.formattedDate.toString();
                renderTimeTable(date.date);
            },
            // marking available session date
            onRenderCell: function ({ date, cellType }) {
                if (methodOfPlaying === "individual") {
                    if (cellType === 'day') {
                        const adjustedDate = new Date(date);
                        adjustedDate.setDate(adjustedDate.getDate() + 1);

                        const formattedDate = adjustedDate.toISOString().split('T')[0];

                        // @ts-ignore
                        if (markedDates.includes(formattedDate)) {
                            return {
                                classes: '-marked-',
                            };
                        }
                    }
                }
            }
        });

        // set on first time page loaded
        renderTimeTable(datepickerInstance.selectedDates);

        const nextDate = () => {
            var next = new Date(dates);
            next.setDate(next.getDate() + 1);
            dates = next.toLocaleDateString();
            $(".js-currentDate").html(transformDates(next.toLocaleDateString()));
            datepickerInstance.selectDate(next);
        }

        const prevDate = () => {
            var prev = new Date(dates);
            prev.setDate(prev.getDate() - 1);
            dates = prev.toLocaleDateString();
            $(".js-currentDate").html(transformDates(prev.toLocaleDateString()));

            datepickerInstance.selectDate(prev);
        }

        $(".js-nextDate").on("click", nextDate);
        $(".js-prevDate").on("click", prevDate);

    }

    const openDropdown = () => {
        const $dropdown = $(".js-timezone-dropdown");
        const $selectedRegion = $('input[name="timezone"]:checked').parent();

        $dropdown.prepend($selectedRegion);
        const isOpen = $(".js-timezone-dropdown").hasClass("is-open");

        $(".js-timezone-dropdown").toggleClass("is-open", !isOpen);
    }

    const closeDropdownOnOutsideElement = () => {
        const dropdownList = $(".js-timezone-dropdown");

        window.addEventListener('mouseup', function (event) {
            const target = event.target;

            if (target instanceof Element && !target.closest(".js-timezone-dropdown, .js-timezone-button")) {
                dropdownList.removeClass("is-open");
            }
        });
    };

    const pickTimezone = () => {
        const value = $('input[name="timezone"]:checked').val();
        const stringValue = typeof value === 'string' ? value : String(value);

        onChangeTimezone(value);

        $(".js-timezone-time").html(stringValue);
        $(".js-timezone-dropdown").removeClass("is-open");
    };

    // <!-- PREPARE TIMEZONE OPTION -->
    // const pickTimezone = () => {
    //     const selectElement = $('#session-timezone');
    //     const value = selectElement.val();
    //     // console.log(value)

    //     onChangeTimezone(value);

    //     // Update the displayed timezone (if needed)
    //     $('.js-timezone-time').text(value);
    // };

    const openSidebar = (e) => {
        const $this = $(e.currentTarget);
        const $sideBar = $(".js-sidebar");
        const isFromCreateBtn = $this.hasClass("js-add-session");
        const isSideBarOpened = $(".js-sidebar").hasClass("is-open");
        const template = $("#js-sidebar-template").html();
        let isEnlisted = false;
        let html;
        let data;
        let selectedTime;

        // open sidebar from plus button
        if (isFromCreateBtn) {
            let formated_date = $(".js-currentDate").text();
            let selected_time = $this
                .closest(".js-session-container")
                .attr("data-time");

            if ($this.hasClass("time-15")) {
                selected_time = selected_time.replace(":00", ":15");
            } else if ($this.hasClass("time-30")) {
                selected_time = selected_time.replace(":00", ":30");
            } else if ($this.hasClass("time-45")) {
                selected_time = selected_time.replace(":00", ":45");
            }

            let timezone = $(".js-timezone-item:checked").val();
            var convertedDate = convertTexttoDateFormat(formated_date);
            const { selectedTimeUTC } = transformTimezone(
                convertedDate,
                selected_time,
                timezone,
            );
            data = {
                formated_date: $(".js-currentDate").text(),
                selected_time: selectedTimeUTC,
            };

            selectedTime = selected_time;
        } else {
            // open sidebar from session card
            const sessionID = $this.attr("data-id");
            const sessionTime = $this.attr("data-time");
            let indexTime = sessionTime;
            if ($this.hasClass("increment-1")) {
                indexTime = indexTime.replace(":00", ":15");
            } else if ($this.hasClass("increment-2")) {
                indexTime = indexTime.replace(":00", ":30");
            } else if ($this.hasClass("increment-3")) {
                indexTime = indexTime.replace(":00", ":45");
            }

            const sessionDate = $this
                .parents(".js-session-timeTable")
                .attr("data-session-date");
            const sessions = CONFIG.game.sessions;
            let userTimezone = $(".js-timezone-item:checked").val();

            isEnlisted = $this.hasClass("-enlisted-");
            selectedTime = indexTime;

            const thisTimeSessions = sessions[sessionDate]?.[indexTime] || [];
            const selectedSession = thisTimeSessions.find(
                (session) => session.ID === sessionID,
            );

            const { schedule_date, schedule_time, timezone, is_expired } =
                selectedSession;
            const formatedDate = transformDates(schedule_date);
            let prepDataDate =
                schedule_date + " " + schedule_time + " " + timezone;

            // this returns inconsistency, for example CET case, in PHP CET is always GMT+1 doesn't support DST, while in moment JS it supports DST
            const selectedTimeUTC = convertTimezone(prepDataDate, userTimezone);
            data = {
                ...selectedSession,
                formated_date: formatedDate,
                selected_time: selectedTimeUTC,
            };

            $sideBar
                .attr("data-session-id", sessionID)
                .addClass("is-update-view")
                .toggleClass("is-session-expired", is_expired || false);
        }

        html = compile(template, data);

        $sideBar.html(html);
        $sideBar.addClass("is-open").attr("data-selected-time", selectedTime);
        $(".js-session-timeTable").addClass("sidebar-opened");

        toggleCreateSessionBtn();
        toggleDisableRegionPicker(isSideBarOpened);

        if (isEnlisted) $(".js-enroll-buttons").addClass("is-enrolled");
    };

    const closeSidebar = () => {
        let isSideBarOpened = $('.js-sidebar').hasClass("is-open");
        if (isSideBarOpened) {
            toggleDisableRegionPicker(isSideBarOpened)
        }
        $(".js-sidebar").removeClass("is-open is-update-view is-session-expired");
        $(".js-session-timeTable").removeClass("sidebar-opened");
    }

    const toggleDisableRegionPicker = (isSideBarOpened) => {
        if (isSideBarOpened) {
            $(".js-timezone-button").prop('disabled', false);
            $(".session_timeTable-main--container").css({ "pointer-events": "all" })
        }
        if (!isSideBarOpened) {
            $(".js-timezone-button").prop('disabled', true);
            $(".session_timeTable-main--container").css({ "pointer-events": "none" })
        }
    }

    const addItem = () => {
        const $emailList = $(".js-email-list");
        const $inputEmail = $(".js-input-email");
        const emailAddress = String($inputEmail.val()).trim();

        if (emailAddress === "") return;

        // prettier-ignore
        // eslint-disable-next-line
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        const testString = emailRegex.test(emailAddress); // check if the string contain html tag

        if (!testString) {
            $inputEmail.parent().addClass("is-email-invalid");
            alert("invalid email")
            return;
        }

        const addedEmail =
            '<div class="session_sidebar-input--item js-email-member">' +
            '<button class="remove-item js-remove-item"></button>' +
            '<span class="js-email-name">' +
            emailAddress +
            '</span></div>';

        $emailList.append(addedEmail);
        $inputEmail.val("");

        updateTotalMember();
        toggleAddMemberBtn();
        toggleCreateSessionBtn();
    }

    const onInputEmail = () => {
        const $inputEmail = $(".js-input-email");

        $inputEmail.parent().removeClass("is-email-invalid");
    }

    const onEnterInputEmail = (e) => {
        const key = e.which || e.keyCode || 0;
        const isEnterKey = key == 13;
        if (isEnterKey && !e.shiftKey) {
            e.preventDefault();
            $(".js-add-item").trigger("click");
            return false;
        }
    }

    const toggleAddMemberBtn = () => {
        const setting = CONFIG.game.settings;
        const { max_players } = setting;
        const $inputEmail = $(".js-input-email");
        const $addMemberBtn = $(".js-add-item");
        const $memberList = $(".js-email-list")
        const $emailMember = $(".js-email-name");
        const totalMember = $emailMember.length;
        const isDisabledBtn = totalMember == max_players;

        $inputEmail.prop("readonly", isDisabledBtn);
        $addMemberBtn.prop("disabled", isDisabledBtn);
        $addMemberBtn
            .parent()
            .toggleClass("is-member-full", isDisabledBtn)
        $memberList.toggleClass("is-member-full", isDisabledBtn)
    }

    const updateTotalMember = () => {
        const $emailMember = $(".js-email-name");
        const totalMember = $emailMember.length;
        const $totalMembertxt = $(".js-total-members");

        $totalMembertxt.text(totalMember);
    }

    const validateSessionNameString = () => {
        const $this = $(".js-session-name");
        const value = String($this.val()).trim();
        const testString = /<\/?[a-z][\s\S]*>/i.test(value); // check if the string contain html tag
        let isValid = false;

        if (value.length > 0 && !testString) isValid = true;

        return isValid;
    }

    const toggleCreateSessionBtn = () => {
        const setting = CONFIG.game.settings;
        const { min_players } = setting;
        const isSessionNameValid = validateSessionNameString();
        const $emailMember = $(".js-email-name");
        const totalMember = $emailMember.length;
        const $createSessionBtn = $(".js-create-session");
        const isDisabledBtn =
            totalMember < min_players ||
            totalMember <= 0 ||
            !isSessionNameValid;

        if (isDisabledBtn) {
            $createSessionBtn.prop("title", `Please fill the Title and at least ${min_players} Registrants`);
            $createSessionBtn.css("cursor", "not-allowed");
        } else {
            $createSessionBtn.prop("title", "Create Session");
            $createSessionBtn.css("cursor", "pointer");
        }

        $createSessionBtn.prop("disabled", isDisabledBtn);
    }

    const removeItem = (e) => {
        const $this = $(e.currentTarget);
        const $selectedMember = $this.parent();

        $selectedMember.remove();

        updateTotalMember();
        toggleAddMemberBtn();
        toggleCreateSessionBtn();
    }

    let isLoading = false;
    const onCreateSession = async (e) => {
        if (isLoading) return false;

        const $this = $(e.currentTarget);
        const $emailMembers = $(".js-email-member");
        const date = $(".js-session-timeTable").attr("data-session-date");
        const time = $(".js-sidebar").attr("data-selected-time");
        const sessionName = $(".js-session-name").val();
        const selectedTimezone = $(".js-timezone-item:checked").val();
        // check if no email member list
        if ($emailMembers.length == 0) return;

        let members = [];
        $.each($emailMembers, function (index, item) {
            const theEMail = $(item).find(".js-email-name").text();
            if (theEMail !== "") members.push(theEMail);
        });

        isLoading = true;
        $this
            .prop("disabled", isLoading)
            .addClass("is-loading");

        const [res] = await bdjs.goAsync(
            bdapi.post("public/create-session", {
                date: date,
                time: time,
                members: members,
                session_name: sessionName,
                timezone: selectedTimezone
            }),
        );

        isLoading = false;
        $this
            .removeClass("is-loading")
            .prop("disabled", isLoading);

        const restData = res?.data || {};

        if (restData?.success) {
            const $popupSuccess = $(".js-popup-success");

            $popupSuccess.find(".js-popup-title").html(restData.data.title);
            $popupSuccess.find(".js-popup-subtitle").html(restData.data.subtitle);

            setTimeout(function () {
                $popupSuccess.addClass("is-open is-after-ajax");
            }, 100);

        } else {
            const msg =
                restData?.data?.message ||
                "Something went wrong. Please try again!";

            $snackBar.addClass("is-active").find(".snackbar__body").html(msg);
        }
    }

    const openEnrollSessionPopup = () => {
        const setting = CONFIG.game.settings;
        let text = setting.enroll_session_individual_confirmation_text
        const $enrollPopup = $(".js-enroll-popup");
        const sessionDateTxt = $(".js-session-date").text();

        $enrollPopup.addClass("is-open");
        let newStr = ''
        if (text.includes("{session_datetime}")) {
            newStr = text.replace("{session_datetime}", sessionDateTxt);
        }
        $(".js-session-date-popup").html(newStr);

    }

    const openUnenrollSessionPopup = () => {
        const setting = CONFIG.game.settings;
        let text = setting.unenroll_session_individual_confirmation_text
        const $unenrollPopup = $(".js-unenroll-popup");
        const sessionDateTxt = $(".js-session-date").text();

        $unenrollPopup.addClass("is-open");
        let newStr = ''
        if (text.includes("{session_datetime}")) {
            newStr = text.replace("{session_datetime}", sessionDateTxt);
        }
        $(".js-session-date-popup").html(newStr);
    }

    const onEnrollSession = async (e) => {
        if (isLoading) return false;

        const $this = $(e.currentTarget);
        const sessionID = $(".js-sidebar").attr("data-session-id");

        isLoading = true;
        $this.addClass("is-loading");

        const [res] = await bdjs.goAsync(
            bdapi.post("public/join-session", {
                session_id: sessionID
            }),
        );

        $this.removeClass("is-loading");
        const restData = res?.data || {};
        const isSuccess = restData?.success || false;
        let title, subtitle;

        if (isSuccess) {
            title = restData?.data?.title;
            subtitle = restData?.data?.subtitle;
        } else {
            title = restData?.data?.message?.title;
            subtitle = restData?.data?.message?.message;
        }

        const $popupSuccess = $(".js-popup-success");
        $popupSuccess.find(".js-popup-title").html(title);
        $popupSuccess.find(".js-popup-subtitle").html(subtitle);
        setTimeout(function () {

            isLoading = false;
            $(".js-enroll-popup").removeClass("is-open");

            setTimeout(function () {
                $popupSuccess.addClass("is-open is-after-ajax");
                if (isSuccess) $(".js-enroll-buttons").addClass("is-enrolled");
            }, 200)
        }, 100);

    }

    const onUnenrollSession = async (e) => {
        if (isLoading) return false;

        const $this = $(e.currentTarget);
        const sessionID = $(".js-sidebar").attr("data-session-id");

        isLoading = true;
        $this.addClass("is-loading");

        const [res] = await bdjs.goAsync(
            bdapi.post("public/unenroll-session", {
                session_id: sessionID
            }),
        );

        $this.removeClass("is-loading");
        const restData = res?.data || {};

        const $popupSuccess = $(".js-popup-success");
        $popupSuccess.find(".js-popup-title").html(restData.data.title);
        $popupSuccess.find(".js-popup-subtitle").html(restData.data.subtitle);

        if (restData?.success) {
            isLoading = false;
            setTimeout(function () {
                $(".js-unenroll-popup").removeClass("is-open")

                setTimeout(function () {
                    $popupSuccess.addClass("is-open is-after-ajax")
                    $(".js-enroll-buttons").removeClass("is-enrolled")
                }, 200);
            }, 100);
        }
    }

    const closePopup = (e) => {
        e.stopPropagation();
        const $popup = $(".popup");
        const isAfterAjax = $popup.hasClass("is-after-ajax");

        $popup.removeClass("is-open");

        if (isAfterAjax) {
            setTimeout(function () {
                window.location.reload();
            }, 200);
        }
    }

    const onChangeTimezone = async (timezone) => {
        const [res] = await bdjs.goAsync(
            bdapi.post("member/update-timezone", {
                selected_timezone: timezone
            }),
        );

        const restData = res?.data || {};
        const isSideBarOpened = $(".js-sidebar").hasClass("is-open");

        if (restData?.success) {
            if (!isSideBarOpened) window.location.reload();
        }
    }

    const scrollToTime = () => {
        let section = $('.js-session-timeTable');
        let timePosition = $(".js-time")[8].offsetTop;

        section.animate({
            scrollTop: timePosition,
        }, 500);
    }

    closeDropdownOnOutsideElement();
    $(document).ready(scrollToTime);
    $(document).on("click", ".js-session-item", openSidebar);
    $(document).on("click", ".js-remove-item", removeItem);
    $(document).on("click", ".js-add-item", addItem);
    $(document).on("click", ".js-close-sidebar", closeSidebar);
    $(document).on("click", ".js-create-session", onCreateSession);
    $(document).on("click", ".js-enroll-session", openEnrollSessionPopup);
    $(document).on("click", ".js-enroll-this", onEnrollSession);
    $(document).on("click", ".js-enroll-cancel", closePopup);
    $(document).on("click", ".js-unenroll-session", openUnenrollSessionPopup);
    $(document).on("click", ".js-popup-close", closePopup);
    $(document).on("click", ".js-unenroll-this", onUnenrollSession);
    $(document).on("click", ".js-add-session", openSidebar);
    $(document).on("input", ".js-session-name", toggleCreateSessionBtn);
    $(document).on("keypress", ".js-input-email", onEnterInputEmail);
    $(document).on("input", ".js-input-email", onInputEmail);
    $(document).on("change", ".js-timezone", onChangeTimezone);
    $(document).on("click", ".js-timezone-button", openDropdown)
    $(document).on("click", ".js-timezone-item", pickTimezone)
    // PREPARE TIMEZONE OPTION 
    // $(document).on("change", "#session-timezone", pickTimezone);
    // $(document).ready(function() {
    //     $('.selectize').selectize();
    // });
    DatePicker();
};
